import React, { PureComponent } from "react";
import Slider from "react-slick";

import { TTP_EVENT_URL, TTP_PORTAL_URL, LAYOUT_DISPOSITIONS } from "Config";
import EventContainer from "../Event/EventContainer";

import _ from "i18n";

export default class EventsListComponent extends PureComponent {
  renderEvents() {
    const { community, fetching, fetched, events, disposition } = this.props;

    if (fetching) {
      return (
        <div id="event-fetching" className="grid-x">
          {[1, 2, 3, 4].map(el => (
            <div
              className="cell small-12 medium-4 large-3"
              key={`event-fetching-${el}`}
            >
              <span />
            </div>
          ))}
        </div>
      );
    }

    if (!fetched || !events || events.length === 0) {
      return null;
    }

    let passed = [];
    let notYet = [];
    let eventsTime = [];
    let eventsPassedTime = [];

    for (let i = 0; i < events.length; i++) {
      let help = new Date(events[i].eventDate).getTime();
      if (help < new Date().getTime()) {
        passed.push({ ...events[i] });
        eventsPassedTime.push(help);
      } else {
        notYet.push({ ...events[i] });
        eventsTime.push(help);
      }
    }

    let sortedPassedEvn = [...passed];
    for (let i = 0; i < sortedPassedEvn.length - 1; i++) {
      for (let j = i + 1; j < sortedPassedEvn.length; j++) {
        if (eventsPassedTime[j] <= eventsPassedTime[i]) {
          let help = { ...sortedPassedEvn[j] };
          sortedPassedEvn[j] = { ...sortedPassedEvn[i] };
          sortedPassedEvn[i] = help;
          let help1 = eventsPassedTime[j];
          eventsPassedTime[j] = eventsPassedTime[i];
          eventsPassedTime[i] = help1;
        }
      }
    }

    let sortedEvn = [...notYet];
    for (let i = 0; i < sortedEvn.length - 1; i++) {
      for (let j = i + 1; j < sortedEvn.length; j++) {
        if (eventsTime[j] <= eventsTime[i]) {
          let help = { ...sortedEvn[j] };
          sortedEvn[j] = { ...sortedEvn[i] };
          sortedEvn[i] = help;
          let help1 = eventsTime[j];
          eventsTime[j] = eventsTime[i];
          eventsTime[i] = help1;
        }
      }
    }

    sortedEvn = [...sortedEvn, ...sortedPassedEvn];

    let helpBlocTypes = [];
    let counter = 0;
    for (let disp of disposition) {
      if (counter >= sortedEvn.length) {
        break;
      }
      counter += LAYOUT_DISPOSITIONS.EVENT[disp];
      helpBlocTypes.push(disp);
    }

    let blocs = [];

    let i = 0;
    for (const blocType of helpBlocTypes) {
      let nbEvent = LAYOUT_DISPOSITIONS.EVENT[blocType];
      let blocEvent = [];

      switch (blocType) {
        case "B1":
          for (let j = i; j < Math.min(sortedEvn.length, i + nbEvent); j++) {
            blocEvent.push(
              <li
                className="cell smal-12 medium-6 large-3"
                key={`event-container-${sortedEvn[j].id}`}
              >
                <EventContainer event={sortedEvn[j]} community={community} />
              </li>
            );
          }
          blocs.push(
            <div className="slick-block" key={Math.random()}>
              <ul className="grid-x">{blocEvent.map(bloc => bloc)}</ul>
            </div>
          );
          break;
      }
      i += nbEvent;
    }

    const settings = {
      dots: true,
      dotsClass: "slick-dots",
      infinite: true,
      arrows: false,
      speed: 500,
      autoplay: false
    };

    return (
      <div className="section-content">
        <Slider {...settings}>{blocs}</Slider>
      </div>
    );

    /*let blocEvent = [];
    for (let i = 0; i < sortedEvn.length; i += 4) {
      if (blocEvent.length >= 3) {
        break;
      }
      blocEvent[i / 4] = [];
      for (let j = i; j < Math.min(sortedEvn.length, i + 4); j++) {
        blocEvent[i / 4].push(
          <li
            className="cell smal-12 medium-6 large-3"
            key={`article-container-${sortedEvn[j].id}`}
          >
            <EventContainer
              event={sortedEvn[j]}
              community={community}
              index={j}
            />
          </li>
        );
      }
    }

    const settings = {
      dots: true,
      dotsClass: "slick-dots",
      infinite: true,
      arrows: false,
      speed: 500,
      autoplay: false
    };

    return (
      <div className="section-content">
        <Slider {...settings}>
          {blocEvent.map(bloc => (
            <div className="slick-block" key={Math.random()}>
              <ul className="grid-x">{bloc}</ul>
            </div>
          ))}
        </Slider>
      </div>
    );

    /*return (
      <div className="section-content">
        <ul className="grid-x">
          {events.map((event, index) => (
            <li
              className="cell small-12 medium-4 large-3"
              key={`event-container-${event.id}`}
            >
              <EventContainer
                event={event}
                community={community}
                index={index}
              />
            </li>
          ))}
        </ul>
      </div>
    );*/
  }

  render() {
    const { lng, community, order } = this.props;

    const { hubPreferences } = community;

    let currentBloc = null;
    let title = _("Agenda");
    let subtitle = _("All the best events and training in our community");

    if (hubPreferences && hubPreferences.layout_settings) {
      currentBloc = hubPreferences.layout_settings.filter(
        bloc => bloc.order === +order
      );
    }
    if (currentBloc && currentBloc.length > 0) {
      if (
        currentBloc[0][`title${lng.toUpperCase()}`] &&
        currentBloc[0][`title${lng.toUpperCase()}`].length > 0
      ) {
        title = currentBloc[0][`title${lng.toUpperCase()}`];
      }
      if (
        currentBloc[0][`subtitle${lng.toUpperCase()}`] &&
        currentBloc[0][`subtitle${lng.toUpperCase()}`].length > 0
      ) {
        subtitle = currentBloc[0][`subtitle${lng.toUpperCase()}`];
      }
    }

    let createEventUrl = `${TTP_EVENT_URL}/${lng}/bo/0/config/add/7/${
      community.id
    }?backto=${TTP_PORTAL_URL}`;

    return (
      <section id="new-community-events">
        <div className="section-body">
          <div className="section-header">
            <div className="section-title">
              <div className="section-title-head">
                <h2>{title}</h2>
                <a href={TTP_EVENT_URL} alt="" className="go-app">
                  {_("Event")}
                </a>
              </div>
              <p className="section-title-subhead">{subtitle}</p>
            </div>
            <div className="section-btn">
              <a
                href={createEventUrl}
                target="_blanc"
                alt=""
                className="btn-action"
              >
                <span>+</span> {_("Create Event")}
              </a>
              <a
                href={TTP_EVENT_URL}
                target="_blanc"
                alt=""
                className="btn-see-more"
              >
                {_("See more")}
              </a>
            </div>
          </div>
          {this.renderEvents()}
        </div>
      </section>
    );
  }
}

// Conn



// WEBPACK FOOTER //
// ./src/components/Community/NewCommunity/EventsList/EventsListComponent.js